// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__15rC9","label":"Section_label__3Tb54","contentWrap":"Section_contentWrap__18_KA","footer":"Section_footer__2R6wE","footerInner":"Section_footerInner__1mDWt"};